import React, {useState} from "react";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Fade from '@material-ui/core/Fade';
import ListItemText from "@material-ui/core/ListItemText";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import {
  apollo_useStyles,
  Option,
} from "../atom/Apollo_styles_Beta";
import {
  options_download_kind,
} from "../atom/Apollo_Options";
import {
  DOWNLOAD_KIND,
} from "../common/Apollo_CommonConst_Beta";

export const ApolloIconButton: React.FC<{ handleButton: () => void, button?: string, title?: string, text?: string, disabled?: boolean, width?: number }> = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const classes = apollo_useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const title = props.title ? props.title : "未設定";
  const button = props.button ? props.button : "未設定";
  const text = props.text + "しますか？";
  const disabled = props.disabled ? props.disabled : false;
  const width = props.width ? props.width : 30;

  return (
    <React.Fragment>

      <Tooltip title={title} placement="bottom">
        <IconButton
          aria-label="more"
          aria-controls="system-menu"
          aria-haspopup="true"
          color="inherit"
          onClick={handleClickOpen}
          disabled={disabled}
        >
          <img src={button} alt="setting" height="auto" width={width}/>
        </IconButton>
      </Tooltip>


      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              handleClose();
              props.handleButton();
            }}
            color="primary"
            autoFocus
          >
            {props.text}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export const ApolloIconButtonDownloadImage: React.FC<{ handleDownload: () => void, handleDownloadImage: (value: number) => void, title: string, disabled?: boolean }> = (props) => {
  const classes = apollo_useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDownload = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const value = Number(event.currentTarget.getAttribute('value'));
    switch (value) {
      case DOWNLOAD_KIND.JPEG:
      case DOWNLOAD_KIND.PNG:
        props.handleDownloadImage(value);
        break;
      case DOWNLOAD_KIND.CSV:
        props.handleDownload();
        break;
    }
    handleClose();
  };

  const disabled = props.disabled ? props.disabled : false;

  return (
    <React.Fragment>
      <Tooltip title={props.title}>
        <IconButton aria-label="download" onClick={handleClickOpen} disabled={disabled}>
          <CloudDownloadIcon/>
        </IconButton>
      </Tooltip>

      <Menu
        id="download-menu"
        anchorEl={anchorEl}
        color="primary"
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {
          options_download_kind.map((option: Option, index: number) =>
            <MenuItem onClick={handleClickDownload} className={classes.menuItemFocus} value={option.value}>
              <ListItemText primary={option.label}/>
            </MenuItem>
          )
        }
      </Menu>
    </React.Fragment>
  )
}